<template>
  <div class="home">
    <Nav></Nav>
    <header class="header">
      <div class="header-content">
        <div class="flex-center">
          <el-image
            data-aos="fade-in"
            class="banner-image hidden-lg-and-down"
            lazy
            :src="require('../assets/images/banner.png')"
            onerror="../assets/images/loading/banner.png"
            alt="">
          </el-image>
          <el-image 
            class="banner-image hidden-xl-only hidden-sm-only hidden-xs-only"
            lazy 
            :src="require('../assets/images/banner-md.png')" 
            onerror="../assets/images/loading/banner.png"
            alt="">
          </el-image>
          <el-image 
            class="banner-image banner-image-position hidden-xl-only hidden-lg-only hidden-md-only hidden-xs-only"
            lazy 
            :src="require('../assets/images/banner-sm.png')" 
            onerror="../assets/images/loading/banner.png"
            alt="">
          </el-image>
          <el-image 
            class="banner-image banner-image-position hidden-xl-only hidden-lg-only hidden-md-only hidden-sm-only"
            lazy 
            :src="require('../assets/images/banner-xs.png')" 
            onerror="../assets/images/loading/banner.png"
            alt="">
          </el-image>
        </div>
        <div class="text-container">
          <div class="header-main">
            <p class="text-slogan">
              <span class="text-color">更快、更省</span><span>的硬“核”渲染平台</span>
            </p>
            <!-- <div class="register-input flex-center">
              <el-input 
                placeholder="请输入手机号"  
                type="text" 
                v-model.number="phone" 
                maxlength="11"
                oninput="value=value.replace(/[^\d]/g,'')" 
                class="input-with-select"
                @keyup.enter.native="registerClick"
                clearable>
                  <el-button class="input-append" 
                  slot="append" 
                  type="success"  
                  @click="registerClick"
                  >领20元代金券</el-button>
              </el-input>
            </div> -->
          </div>
        </div>
      </div>
    </header>
    <!-- 工作助手 -->
    <section class="section home-feature" data-aos="fade-up" data-aos-duration="1000">
      <div class="subtitle hidden-xs-only">建筑可视化行业的贴身管家、设计师的得力助手</div>
      <div class="subtitle hidden-sm-and-up">建筑可视化行业的贴身管家<br/>设计师的得力助手</div>
      <p class="subtitle-desc">后续将会支持更多软件</p>
      <!-- 支持软件 -->
      <el-row class="container software-list">
        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="flex-center flex-align-center">
            <div class="software-item">
              <div class="software-img">
                <img src="../assets/images/3ds-max.png" alt="">
              </div>
              <p class="software-text">3ds Max</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="flex-center flex-align-center">
            <div class="software-item">
              <div class="software-img">
                <img src="../assets/images/Corona.png" alt="">
              </div>
              <p class="software-text">Corona</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="flex-center flex-align-center">
            <div class="software-item last-software-item">
              <div class="software-img">
                <img src="../assets/images/V-Ray.png" alt="">
              </div>
              <p class="software-text">V-Ray</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="flex-center flex-align-center">
            <div class="software-item last-software-item">
              <div class="software-img">
                <img src="../assets/images/sketchup.png" alt="">
              </div>
              <p class="software-text">Sketchup</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 支持软件结束 -->
      <!-- 功能开始 -->
      <div class="container">
        <ul class="function-list flex-align-center">
          <li class="flex-center function-item">
            <div class="function">
              <div class="function-img">
                <img src="../assets/images/icon-submit.png" alt="">
              </div>
              <p class="function-text">一键提交</p>
            </div>
          </li>
          <li class="flex-center function-item">
            <div class="function">
              <div class="function-img">
                <img src="../assets/images/icon-ao.png" alt="">
              </div>
              <p class="function-text">AO/通道</p>
            </div>
          </li>
          <li class="flex-center function-item">
            <div class="function">
              <div class="function-img">
                <img src="../assets/images/icon-camera.png" alt="">
              </div>
              <p class="function-text">多相机渲染</p>
            </div>
          </li>
          <li class="flex-center function-item">
            <div class="function">
              <div class="function-img">
                <img src="../assets/images/icon-photon.png" alt="">
              </div>
              <p class="function-text">智能光子</p>
            </div>
          </li>
          <li class="flex-center function-item">
            <div class="function">
              <div class="function-img">
                <img src="../assets/images/icon-preview.png" alt="">
              </div>
              <p class="function-text">实时预览</p>
            </div>
          </li>
          <li class="flex-center last-function function-item hidden-md-and-up">
            <div class="function ">
              <div class="function-img">
                <img src="../assets/images/icon-more.png" alt="">
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 功能结束 -->
      <!-- 特色服务开始 -->
      <div class="container service-list flex-between">
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center service-item">
            <div class="">
              <div class="service-img">
                <img src="../assets/images/icon-server.png" alt="">
              </div>
              <p class="software-text">1w+服务器</p>
            </div>
          </div>
        <!-- </el-col> -->
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center flex-center service-item">
            <div class="">
              <div class="service-img">
                <img src="../assets/images/icon-dispatch.png" alt="">
              </div>
              <p class="software-text">后台智能调度</p>
            </div>
          </div>
        <!-- </el-col> -->
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center flex-center service-item">
            <div class="">
              <div class="service-img">
                <img src="../assets/images/icon-support.png" alt="">
              </div>
              <p class="software-text">资深TD支持</p>
            </div>
          </div>
        <!-- </el-col> -->
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center flex-center service-item">
            <div class="">
              <div class="service-img">
                <img src="../assets/images/icon-security.png" alt="">
              </div>
              <p class="software-text">高效数据安全</p>
            </div>
          </div>
        <!-- </el-col> -->
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center flex-center service-item">
            <div class="">
              <div class="service-img">
                <img src="../assets/images/icon-rapidly.png" alt="">
              </div>
              <p class="software-text">极速传输</p>
            </div>
          </div>
        <!-- </el-col> -->
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center flex-end service-item">
            <div class="">
              <div class="service-img">
                <img src="../assets/images/icon-custom.png" alt="">
              </div>
              <p class="service-text">定制化服务</p>
            </div>
          </div>
        <!-- </el-col> -->
      </div>
      <!-- 特色服务结束 -->
    </section>
    <!-- 工作助手结束 -->
    <!-- 注册按钮 -->
    <!-- <section class="flex-center download-now">
      <div class="">
        <p class="download-header">注册就送20元无门槛渲染费</p>
        <a target="_blank" href="https://s.rendercool.com/#/register?flag=register"><div class="download-btn">点击领取</div></a>
      </div>
    </section> -->
    <!-- 注册按钮结束 -->
    <!-- 案例展示 -->
    <section class="container case-list" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out">
      <div class="subtitle">案例展示</div>
      <el-carousel :interval="4000" type="card" :height="carouselHeight">
        <el-carousel-item v-for="item in carouselList" :key="item.id">
          <img style="width: 100%;" :src="item.url" alt="">
        </el-carousel-item>
      </el-carousel>
    </section>
    <!-- 案例展示结束 -->
    <!-- 关于我们开始 -->
    <section class="aboutus-box" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out">
      <ul>
        <li class="aboutus-item">
          <p class="aboutus-title">CONTACT US</p>
          <div class="flex-align-center flex-center ">
            <p class="flex-align-center aboutus-phone">
              <img class="mr5 aboutus-img " src="../assets/images/icon-phone.png" alt="">
              <span class="about-text">15083301945</span>
            </p>
            <p class="flex-align-center">
              <img class="mr5 aboutus-img" src="../assets/images/icon-qq.png" alt="">
              <span class="about-text">1478887151</span>
            </p>
          </div>
        </li>
        <li class="aboutus-item">
          <p class="aboutus-title">LINK</p>
          <div class="flex-align-center flex-center ">
            <a href="https://www.rendercool.com/" rel="noopener noreferrer" class="about-text">www.rendercool.com</a>
          </div>
        </li>
        <li class="aboutus-item">
          <p class="aboutus-title">ADD</p>
          <div class="flex-align-center flex-center ">
            <p class="about-text">宁夏中卫市沙坡头区中卫工业园区云天中卫众创空间4楼</p>
          </div>
        </li>
      </ul>
      
    </section>
    <!-- 关于我们结束 -->
    <!-- 右下角固定按钮 -->
    <Position></Position>
    <footer class="flex-center">
      <div class="footer">
        Copyright © {{ year }} rendercool.com 备案号：<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">宁ICP备2023000159号-1</a>
        <a href="sitemap.htm">网站地图</a>
      </div>
    </footer>
  </div>
</template>

<script>
import Nav from '../components/Nav/index'
import Position from '../components/Position/index'
export default {
  name: "Home",
  components: {
    Nav,
    Position
  },
  data() {
    return {
      phone: '',
      showCpu: true,
      showGpu: true,
      showChat: true,
      year: new Date().getFullYear(),
      carouselList:[
        {
          id: 1,
          url: require('../assets/images/carousel/rg2.jpg')
        },
        {
          id: 2,
          url: require('../assets/images/carousel/rg3.jpg')
        },
        {
          id: 3,
          url: require('../assets/images/carousel/rg4.jpg')
        },
        {
          id: 4,
          url: require('../assets/images/carousel/rg8.jpg')
        },
        {
          id: 5,
          url: require('../assets/images/carousel/rg9.jpg')
        },
      ],
      carouselHeight: '400px',
      screenWidth: window.innerWidth,
    }
  },
  mounted() {
    console.log('resize', window.innerWidth)
     window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    registerClick () {
      if (this.phone) {
        window.open('https://s.rendercool.com/#/register?flag=register&phone='+this.phone)
      } else {
        window.open('https://s.rendercool.com/#/register?flag=register')
      }
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth < 991) {
        this.showCpu = true
        this.showGpu = true
        this.carouselHeight = '100px'
      } else {
        this.showCpu = false
        this.showGpu = false
        if (this.screenWidth < 1440) {
          this.carouselHeight = '300px'
        } else {
          this.carouselHeight = '400px'
        }
      }
    },
  },
};
</script>
